import {SoftDeleteEntity} from "./soft-delete-entity";

export class Company extends SoftDeleteEntity {
  public logoId: number;
  public logoFileName: string;
  public logoUrl: string;
  public name: string;
  public brandName: string;
  public directorName: string;
  public directorFirstName: string;
  public directorJobTitle: string;
  public directorJobTitleEn: string;
  public phone: number;
  public email: string;
  public countryIsoCode: number;
  public countryName: string;
  public city: string;
  public address: string;
  public postcode: string;
  public vatRegNr: string;
  public vatRate: number;
  public orderUrl: string;
  public orderMethod: number; // 0 = disabled, 1 = enabled, 2 = appsonly
  public active: boolean;
  public bankName: string;
  public bankSortCode: string;
  public bankBranchNo: string;
  public accountNo: string;
  public iban: string;
  public bic: string;
  public swift: string;
  public cardProcessorEnquiryEnabled: boolean;

  public orderLanguage: number;

  public voucherPaymentEnabled: boolean;
  public invoicePaymentEnabled: boolean;
  public sofortPaymentEnabled: boolean;
  public cashOnDeliveryPaymentEnabled: boolean;
  public creditCardPaymentEnabled: boolean;

  public webIdForBulkOrdersEnabled: boolean;

  public directInvoicingEnabled: boolean;
  public supportEmail: string;
  public supportPhone: string;
  public websiteUrl: string;
  public googleAnalyticsCode: string;
  public facebookPixelId: string;
  public partnerShortCode: string;
  public partnerWalletEnabled: boolean;
  public canCreateWallets: boolean;

  public cardsImageId: number;
  public cardsImageFileName: string;
  public cardsImageUrl: string;

  // social
  public facebookUrl: string;
  public instagramUrl: string;
  public tikTokUrl: string;
  public youTubeUrl: string;

  public customerNumber: string;
  public fxRateMargin: number;

  public partnerWalletDefaultLoadFee: number;
  public brandReferralCode: string|null;

}


